export default "__VITE_ASSET__CW_GHktP__"